/* Express Checkout - SINGLE BUTTON ONLY - MediterraneanArt.ch */
(function() {
  let buttonAdded = false;
  
  function addSingleExpressButton() {
    // Prevent multiple executions
    if (buttonAdded) return;
    
    // Remove ALL existing Mediterranean buttons first
    document.querySelectorAll('.mediterranean-express-checkout').forEach(btn => btn.remove());
    
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    
    // Create the Express Checkout Button
    const expressButton = document.createElement('button');
    expressButton.type = 'button';
    expressButton.className = 'mediterranean-express-checkout';
    expressButton.innerHTML = '<span class="lightning">⚡</span> Jetzt kaufen';
    
    // Express Checkout Click Handler
    expressButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantId = productForm.querySelector('[name="id"]');
      const quantity = productForm.querySelector('[name="quantity"]') || {value: 1};
      
      if (!variantId || !variantId.value) {
        alert('Bitte wählen Sie eine Produktvariante.');
        return;
      }
      
      // Show loading
      expressButton.innerHTML = '<span class="lightning">⚡</span> Wird geladen...';
      expressButton.disabled = true;
      
      // Add to cart and checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId.value,
          quantity: parseInt(quantity.value) || 1
        })
      })
      .then(response => response.json())
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Express checkout error:', error);
        alert('Es gab einen Fehler. Bitte versuchen Sie es erneut.');
        expressButton.innerHTML = '<span class="lightning">⚡</span> Jetzt kaufen';
        expressButton.disabled = false;
      });
    });
    
    // Smart positioning: Find the right place to insert SINGLE button
    const quantityElement = productForm.querySelector('.quantity-selector, [name="quantity"]');
    
    if (quantityElement && quantityElement.parentElement) {
      // Insert right before the quantity selector
      quantityElement.parentElement.insertBefore(expressButton, quantityElement);
      buttonAdded = true;
      console.log('Express button added before quantity selector');
    } else {
      // Fallback: add at top of form
      productForm.insertBefore(expressButton, productForm.firstElementChild);
      buttonAdded = true;
      console.log('Express button added at form start');
    }
  }
  
  // Run once when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSingleExpressButton);
  } else {
    addSingleExpressButton();
  }
  
})();